<template>
  <transition name="kco-fade">
    <div v-if="kioskSession.cardActive" class="kco-backdrop" role="alert" aria-live="polite">
      <div class="kco-card">
        <div class="kco-spinner" aria-hidden="true"></div>
        <h2 class="kco-title">Paga con la carta sul POS</h2>
        <p class="kco-amount">{{ amount }}</p>
        <p class="kco-hint">Avvicina, inserisci o striscia la carta sul terminale e segui le sue istruzioni.</p>
        <p v-if="kioskSession.card.message" class="kco-progress">{{ kioskSession.card.message }}</p>
        <p class="kco-foot">Per annullare usa il tasto Annulla sul terminale.</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { hasKioskBridge } from '@/config/kiosk'
import { kioskSession } from '@/config/kioskSession'

const amount = computed(() => ((Number(kioskSession.card.amount) || 0) / 100).toFixed(2).replace('.', ',') + ' €')

let unsub = null
onMounted(() => {
  // Gli avanzamenti del POS (testi da 20 caratteri) arrivano sullo stesso canale del Cashmatic,
  // distinti da operation === 'card'.
  if (hasKioskBridge()) {
    unsub = window.kioskPay.onProgress((p) => {
      if (p && p.operation === 'card') kioskSession.card.message = p.message || ''
    })
  }
})
onBeforeUnmount(() => { if (unsub) unsub() })
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

.kco-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(9, 11, 40, 0.88);
  font-family: 'Montserrat', sans-serif;
}
.kco-card {
  width: 100%;
  max-width: 560px;
  padding: 40px 32px;
  border-radius: 24px;
  background: #2e348c;
  color: #fff;
  text-align: center;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
}
.kco-spinner {
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
  border-radius: 50%;
  border: 6px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffc933;
  animation: kco-spin 0.9s linear infinite;
}
.kco-title { margin: 0 0 8px; font-size: 1.6rem; font-weight: 700; }
.kco-amount { margin: 0 0 16px; font-size: 2.4rem; font-weight: 700; color: #ffc933; }
.kco-hint { margin: 0 0 16px; font-size: 1.15rem; opacity: 0.9; }
.kco-progress { margin: 0 0 16px; font-size: 1.05rem; font-weight: 600; }
.kco-foot { margin: 8px 0 0; font-size: 0.95rem; opacity: 0.7; }
@keyframes kco-spin { to { transform: rotate(360deg); } }
.kco-fade-enter-active, .kco-fade-leave-active { transition: opacity 0.2s ease; }
.kco-fade-enter-from, .kco-fade-leave-to { opacity: 0; }
</style>
